import { Navigate, useRoutes } from "react-router-dom";

import { Auth } from "pages/authentication/index";
import { Admin as Root } from "pages/admin/index";
import { User as Admin } from "pages/user/index";
import Layout from "pages/Layout/Layout";
import AuthLayout from "pages/Layout/AuthLayout";

import Profile from "pages/profile/form";
import ChangePassword from "pages/changePassword/form";
import PasswordChangeGuard from "components/PasswordChangeGuard";
import RootOnlyGuard from "components/RootOnlyGuard";
import Dashboard from "pages/admin/Dashboard";

function PrivateRoute() {
  let element = useRoutes([
    {
      element: <Layout />,
      children: [
        { path: "/", element: <PasswordChangeGuard><Dashboard /></PasswordChangeGuard> },
        { path: "/dashboard", element: <PasswordChangeGuard><Dashboard /></PasswordChangeGuard> },
        { path: "/profile", element: <PasswordChangeGuard><Profile /></PasswordChangeGuard> },
        { path: "/change-password", element: <ChangePassword /> }, // No guard for change password page

        { path: "/admin/information", element: <PasswordChangeGuard><Root.Information /></PasswordChangeGuard> },
        { path: "/admin/information/create", element: <PasswordChangeGuard><Root.InformationForm /></PasswordChangeGuard> },
        { path: "/admin/information/edit/:id", element: <PasswordChangeGuard><Root.InformationForm /></PasswordChangeGuard> },

        { path: "/admin/role", element: <PasswordChangeGuard><Root.Role /></PasswordChangeGuard> },
        { path: "/admin/role/create", element: <PasswordChangeGuard><Root.RoleForm /></PasswordChangeGuard> },
        { path: "/admin/role/edit/:id", element: <PasswordChangeGuard><Root.RoleForm /></PasswordChangeGuard> },
        { path: "/admin/log", element: <PasswordChangeGuard><Root.Log /></PasswordChangeGuard> },
        { path: "/admin/security-log", element: <PasswordChangeGuard><Root.SecurityLog /></PasswordChangeGuard> },
        
        { path: "/admin/2fa/settings", element: <PasswordChangeGuard><Root.TwoFactorSettings /></PasswordChangeGuard> },
        { path: "/admin/two-factor", element: <PasswordChangeGuard><Root.TwoFactorSettings /></PasswordChangeGuard> },
        { path: "/admin/password-policy", element: <PasswordChangeGuard><RootOnlyGuard><Root.PasswordPolicySettings /></RootOnlyGuard></PasswordChangeGuard> },

        { path: "/banner", element: <PasswordChangeGuard><Admin.Banner /></PasswordChangeGuard> },
        { path: "/banner/create", element: <PasswordChangeGuard><Admin.BannerForm /></PasswordChangeGuard> },
        { path: "/banner/edit/:id", element: <PasswordChangeGuard><Admin.BannerForm /></PasswordChangeGuard> },

        { path: "/about_us", element: <PasswordChangeGuard><Admin.AboutUs /></PasswordChangeGuard> },
        { path: "/careers", element: <PasswordChangeGuard><Admin.Careers /></PasswordChangeGuard> },

        { path: "/goods/services", element: <PasswordChangeGuard><Admin.GoodsServices /></PasswordChangeGuard> },
        { path: "/goods/services/create", element: <PasswordChangeGuard><Admin.GoodsServicesForm /></PasswordChangeGuard> },
        { path: "/goods/services/edit/:id", element: <PasswordChangeGuard><Admin.GoodsServicesForm /></PasswordChangeGuard> },
        { path: "/goods/services/detail/:id", element: <PasswordChangeGuard><Admin.GoodsServicesForm /></PasswordChangeGuard> },

        { path: "/quality", element: <PasswordChangeGuard><Admin.Quality /></PasswordChangeGuard> },
        { path: "/quality/create", element: <PasswordChangeGuard><Admin.QualityForm /></PasswordChangeGuard> },
        { path: "/quality/edit/:id", element: <PasswordChangeGuard><Admin.QualityForm /></PasswordChangeGuard> },
        { path: "/quality/detail/:id", element: <PasswordChangeGuard><Admin.QualityForm /></PasswordChangeGuard> },

        { path: "/machine", element: <PasswordChangeGuard><Admin.Machine /></PasswordChangeGuard> },
        { path: "/machine/create", element: <PasswordChangeGuard><Admin.MachineForm /></PasswordChangeGuard> },
        { path: "/machine/edit/:id", element: <PasswordChangeGuard><Admin.MachineForm /></PasswordChangeGuard> },
        { path: "/machine/detail/:id", element: <PasswordChangeGuard><Admin.MachineForm /></PasswordChangeGuard> },

        { path: "/transport", element: <PasswordChangeGuard><Admin.Transport /></PasswordChangeGuard> },
        { path: "/transport/create", element: <PasswordChangeGuard><Admin.TransportForm /></PasswordChangeGuard> },
        { path: "/transport/edit/:id", element: <PasswordChangeGuard><Admin.TransportForm /></PasswordChangeGuard> },
        { path: "/transport/detail/:id", element: <PasswordChangeGuard><Admin.TransportForm /></PasswordChangeGuard> },

        { path: "/sdgs", element: <PasswordChangeGuard><Admin.SDGS /></PasswordChangeGuard> },
        { path: "/sdgs/create", element: <PasswordChangeGuard><Admin.SDGSForm /></PasswordChangeGuard> },
        { path: "/sdgs/edit/:id", element: <PasswordChangeGuard><Admin.SDGSForm /></PasswordChangeGuard> },
        { path: "/sdgs/detail/:id", element: <PasswordChangeGuard><Admin.SDGSForm /></PasswordChangeGuard> },

        { path: "/certificate", element: <PasswordChangeGuard><Admin.Certificate /></PasswordChangeGuard> },
        { path: "/certificate/create", element: <PasswordChangeGuard><Admin.CertificateForm /></PasswordChangeGuard> },
        { path: "/certificate/edit/:id", element: <PasswordChangeGuard><Admin.CertificateForm /></PasswordChangeGuard> },
        { path: "/certificate/detail/:id", element: <PasswordChangeGuard><Admin.CertificateForm /></PasswordChangeGuard> },

        { path: "/activity", element: <PasswordChangeGuard><Admin.Activity /></PasswordChangeGuard> },
        { path: "/activity/create", element: <PasswordChangeGuard><Admin.ActivityForm /></PasswordChangeGuard> },
        { path: "/activity/edit/:id", element: <PasswordChangeGuard><Admin.ActivityForm /></PasswordChangeGuard> },
        { path: "/activity/detail/:id", element: <PasswordChangeGuard><Admin.ActivityForm /></PasswordChangeGuard> },

        { path: "/logo", element: <PasswordChangeGuard><Admin.Logo /></PasswordChangeGuard> },
        { path: "/logo/create", element: <PasswordChangeGuard><Admin.LogoForm /></PasswordChangeGuard> },
        { path: "/logo/edit/:id", element: <PasswordChangeGuard><Admin.LogoForm /></PasswordChangeGuard> },

        { path: "/job/opening", element: <PasswordChangeGuard><Admin.JobOpening /></PasswordChangeGuard> },
        { path: "/job/opening/create", element: <PasswordChangeGuard><Admin.JobOpeningForm /></PasswordChangeGuard> },
        { path: "/job/opening/edit/:id", element: <PasswordChangeGuard><Admin.JobOpeningForm /></PasswordChangeGuard> },
        { path: "/job/opening/detail/:id", element: <PasswordChangeGuard><Admin.JobOpeningForm /></PasswordChangeGuard> },

        { path: "/job/list", element: <PasswordChangeGuard><Admin.JobList /></PasswordChangeGuard> },
        { path: "/job/list/detail/:id", element: <PasswordChangeGuard><Admin.JobListForm /></PasswordChangeGuard> },

        { path: "/general/policy", element: <PasswordChangeGuard><Admin.Policy /></PasswordChangeGuard> },
        { path: "/general/contact_us", element: <PasswordChangeGuard><Admin.ContactUs /></PasswordChangeGuard> },

        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },
  ]);

  return element;
}

function AuthRoute() {
  let element = useRoutes([
    {
      element: <AuthLayout />,
      children: [
        { path: "/", element: <Auth.Login /> },
        { path: "/login", element: <Auth.Login /> },
        { path: "/forgot-password", element: <Auth.ForgotPassword /> },
        { path: "/change-password/*", element: <Auth.ChangePassword /> },
        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },
  ]);

  return element;
}

export const Render = {
  PrivateRoute,
  AuthRoute,
};
